/* VELORA PDP — per-band color rows, bundle selector, gallery, sticky ATC, ajax cart */
(function(){
  function money(cents){
    if(cents == null || isNaN(cents)) return '';
    return '$' + (cents/100).toFixed(2);
  }

  function initRoot(root){
    var dataEl = root.querySelector('[data-vpdp-variants]') || document.querySelector('[data-vpdp-variants]');
    if(!dataEl) return;
    var variants = [];
    try{ variants = JSON.parse(dataEl.textContent); }catch(e){ return; }

    var bundleIdx = parseInt(root.getAttribute('data-bundle-index')||'1',10);
    var colorAttr = root.getAttribute('data-color-index');
    var colorIdx = colorAttr ? parseInt(colorAttr,10) : null;

    var bundles = Array.prototype.slice.call(root.querySelectorAll('.v-bundle'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('.v-color-row'));
    var idInput = root.querySelector('[data-variant-id]');
    var form = root.querySelector('form');

    var priceCur = root.querySelector('[data-price-current]');
    var priceCmp = root.querySelector('[data-price-compare]');
    var priceSave = root.querySelector('[data-price-save]');
    var atc = root.querySelector('[data-atc]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    // gallery / color-image
    var colorTarget = root.querySelector('[data-color-target]');
    var colorPh = root.querySelector('[data-color-ph]');
    var gSlides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var gThumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var mainDefaultUrl = colorTarget ? (colorTarget.getAttribute('data-default') || '') : '';

    var state = {
      bundle: null,
      colors: rows.map(function(r){ var s = r.querySelector('.v-swatch'); return s ? s.getAttribute('data-value') : null; })
    };
    var def = bundles.find(function(b){ return b.hasAttribute('data-default'); }) || bundles[0];
    if(def) state.bundle = def.getAttribute('data-value');

    function optVal(v, idx){ return (v.options && v.options[idx-1]) || null; }
    function bundleBands(){
      var b = bundles.find(function(x){ return x.getAttribute('data-value') === state.bundle; });
      return b ? parseInt(b.getAttribute('data-bands')||'1',10) : 1;
    }
    function swatchFor(rowIdx, val){
      var r = rows[rowIdx]; if(!r) return null;
      return Array.prototype.slice.call(r.querySelectorAll('.v-swatch')).filter(function(s){ return s.getAttribute('data-value') === val; })[0] || null;
    }
    function findVariant(){
      return variants.find(function(v){
        if(optVal(v,bundleIdx) !== state.bundle) return false;
        if(colorIdx && optVal(v,colorIdx) !== state.colors[0]) return false;
        return true;
      });
    }

    function showMainSlide(){
      gSlides.forEach(function(s,si){ s.style.display = si === 0 ? '' : 'none'; });
      gThumbs.forEach(function(t,ti){ t.classList.toggle('is-active', ti === 0); });
    }
    function applyColorImage(sw){
      if(!colorTarget) return;
      var img = sw ? (sw.getAttribute('data-image') || '') : '';
      var label = sw ? (sw.getAttribute('data-image-label') || '') : '';
      if(img){
        colorTarget.src = img; colorTarget.style.display = '';
        if(colorPh) colorPh.style.display = 'none';
      } else if(mainDefaultUrl){
        colorTarget.src = mainDefaultUrl; colorTarget.style.display = '';
        if(colorPh) colorPh.style.display = 'none';
      } else {
        colorTarget.style.display = 'none';
        if(colorPh){ colorPh.style.display = ''; colorPh.textContent = label ? ('[ ADD ' + label.toUpperCase() + ' PHOTO ]') : '[ PRODUCT IMAGE ]'; }
      }
      showMainSlide();
    }

    function render(){
      var N = bundleBands();
      bundles.forEach(function(b){
        var on = b.getAttribute('data-value') === state.bundle;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true':'false');
      });
      rows.forEach(function(r, i){
        r.style.display = i < N ? '' : 'none';
        var sws = Array.prototype.slice.call(r.querySelectorAll('.v-swatch'));
        sws.forEach(function(s){ s.classList.toggle('is-selected', s.getAttribute('data-value') === state.colors[i]); });
        var nm = r.querySelector('[data-color-name]'); if(nm && state.colors[i]) nm.textContent = state.colors[i];
      });

      var v = findVariant();
      if(v){
        if(idInput) idInput.value = v.id;
        if(priceCur) priceCur.textContent = money(v.price);
        if(priceCmp){
          if(v.compare_at_price && v.compare_at_price > v.price){ priceCmp.textContent = money(v.compare_at_price); priceCmp.style.display=''; }
          else { priceCmp.style.display='none'; }
        }
        if(priceSave){
          if(v.compare_at_price && v.compare_at_price > v.price){ priceSave.textContent = 'Save ' + money(v.compare_at_price - v.price); priceSave.style.display=''; }
          else { priceSave.style.display='none'; }
        }
        if(stickyPrice) stickyPrice.innerHTML = '<b>'+money(v.price)+'</b>';
        if(atc){ atc.disabled=false; var l=atc.querySelector('[data-atc-label]'); if(l && !v.available) l.textContent='Sold Out'; }
      }
    }

    bundles.forEach(function(b){
      b.addEventListener('click', function(){
        state.bundle = b.getAttribute('data-value');
        render();
        applyColorImage(swatchFor(0, state.colors[0]));
      });
    });
    rows.forEach(function(r, i){
      Array.prototype.slice.call(r.querySelectorAll('.v-swatch')).forEach(function(s){
        s.addEventListener('click', function(){ state.colors[i] = s.getAttribute('data-value'); render(); applyColorImage(s); });
      });
    });

    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var v = findVariant();
        if(!v){ window.location = form.getAttribute('action')||'/cart'; return; }
        var N = bundleBands();
        var item = { id: v.id, quantity: 1 };
        if(N > 1 && rows.length){
          var props = {};
          for(var i=0;i<N;i++){ if(state.colors[i]) props['Band ' + (i+1) + ' Color'] = state.colors[i]; }
          item.properties = props;
        }
        if(atc){ atc.disabled = true; var l=atc.querySelector('[data-atc-label]'); if(l){ atc.dataset._t=l.textContent; l.textContent='Adding…'; } }
        fetch('/cart/add.js', {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items:[item] })
        }).then(function(r){ return r.json(); }).then(function(){
          window.location = '/cart';
        }).catch(function(){
          if(atc){ atc.disabled=false; var l2=atc.querySelector('[data-atc-label]'); if(l2 && atc.dataset._t) l2.textContent=atc.dataset._t; }
          form.submit();
        });
      });
    }

    render();
    applyColorImage(swatchFor(0, state.colors[0]));
  }

  // Gallery (thumbnail slide swap)
  function initGallery(root){
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    if(!thumbs.length) return;
    function activate(i){
      slides.forEach(function(s,si){ s.style.display = si===i ? '' : 'none'; });
      thumbs.forEach(function(t,ti){ t.classList.toggle('is-active', ti===i); });
    }
    thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ activate(i); }); });
  }

  // Sticky mobile ATC
  function initSticky(){
    var sticky = document.querySelector('[data-vpdp-sticky]');
    var buy = document.querySelector('[data-vpdp-buy]');
    var stickyBtn = sticky && sticky.querySelector('[data-sticky-atc]');
    var mainAtc = document.querySelector('[data-atc]');
    if(!sticky || !buy) return;
    function onScroll(){
      var r = buy.getBoundingClientRect();
      sticky.classList.toggle('show', r.bottom < 80);
    }
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
    if(stickyBtn && mainAtc){
      stickyBtn.addEventListener('click', function(){
        buy.scrollIntoView({behavior:'smooth', block:'start'});
        setTimeout(function(){ mainAtc.click(); }, 350);
      });
    }
  }

  function boot(){
    document.querySelectorAll('[data-vpdp]').forEach(function(root){ initRoot(root); initGallery(root); });
    initSticky();
  }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
